import React from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import '../../styling/ClientPortal.css';
import GalleryTab from "../tabs/GalleryTab";
import ClientGalleryTab from "../tabs/ClientGalleryTab";
import ClientEventsTable from "../tables/ClientEventsTable";
import ClientOverview from "../ClientOverview";
import ClientEventsTableBusiness from "../tables/ClientEventsTableBusiness";


const ClientLandingPageBusiness = ({ brandingColours, handleTabSwitch, events, clientId, onEventClick, clientData, setInitialBusinessEventTab }) => {



  return (
    <div style={{ paddingTop: '15px', paddingBottom: "15px", paddingRight: "20px"}} className="clientLandingPageTabs">
      <Tabs>
        <TabList>
          <Tab>Overview</Tab>
          <Tab>Events</Tab>
          <Tab>Gallery</Tab>
        </TabList>

        <TabPanel>
            <ClientOverview clientId={clientId} clientData={clientData}/>
        </TabPanel>
 
        <TabPanel>
          <ClientEventsTableBusiness
            event={events}
            brandingColours={brandingColours}
            onEventClick={onEventClick} 
            setInitialBusinessEventTab={setInitialBusinessEventTab}
          />
        </TabPanel>
        <TabPanel>
          <ClientGalleryTab brandingColours={brandingColours} clientId={clientId}/>
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default ClientLandingPageBusiness;